/**
 * 营销素材位（后端 promo_campaigns）
 *
 * slot 是 App 里写死的固定位置，运营往坑里放图：改文案 = 换图上传，不需要发版。
 */

export type PromoSlot = 'promo_modal' | 'home_carousel' | 'home_banner'
export type PromoLinkType = 'none' | 'app' | 'web'
export type PromoPlatform = 'all' | 'ios' | 'android'

export interface PromoCampaign {
  id: number
  code: string
  name: string
  slot: PromoSlot
  sortOrder: number
  imageUrl: string
  linkType: PromoLinkType
  linkValue: string | null
  containsPayment: boolean
  platform: PromoPlatform
  minVersionCode: number | null
  startAt: string | null
  endAt: string | null
  priority: number
  enabled: boolean
  createdAt: string
  updatedAt: string
}

export interface PromoCampaignListResponse {
  campaigns: PromoCampaign[]
}

export interface PromoImageUploadResponse {
  imageUrl: string
}

export interface CreatePromoCampaignRequest {
  code: string
  name: string
  slot: PromoSlot
  sortOrder: number
  imageUrl: string
  linkType: PromoLinkType
  linkValue: string | null
  containsPayment: boolean
  platform: PromoPlatform
  minVersionCode: number | null
  startAt: string | null
  endAt: string | null
  priority: number
  enabled: boolean
}

export type UpdatePromoCampaignRequest = Partial<
  Omit<CreatePromoCampaignRequest, 'code'>
>

export const PromoSlotLabel: Record<PromoSlot, string> = {
  promo_modal: '首页营销弹窗',
  home_carousel: '首页轮播',
  home_banner: '首页横幅',
}

/** 每个 slot 的预期出图尺寸（后台校验用，避免运营传错比例） */
export const PromoSlotImageSpec: Record<PromoSlot, string> = {
  promo_modal: '948×888（3:4 偏方，圆角外透明）',
  home_carousel: '1774×887（2:1 横幅）',
  home_banner: '按页面横幅宽度，2:1 到 3:1 之间',
}

export const PromoLinkTypeLabel: Record<PromoLinkType, string> = {
  none: '不可点击',
  app: 'App 内页面',
  web: '外部网页',
}

export const PromoPlatformLabel: Record<PromoPlatform, string> = {
  all: '全平台',
  ios: '仅 iOS',
  android: '仅 Android',
}

/** 后台常用跳转目标（运营从下拉里挑，避免手写拼错） */
export const PromoLinkPresets: Array<{ label: string; value: string }> = [
  { label: '定价页', value: '/pricing' },
  { label: '题库', value: '/topics' },
  { label: '全真模考', value: '/mock' },
  { label: '会员中心', value: '/member' },
]
